<template>
  <div
    :class="isMobileBreakpoint && 'px-5 text-center'"
    class="d-flex flex-column align-center justify-center error-state__container"
  >
    <img src="@/assets/errorState/analytics.svg" class="error-state__image" />
    <span class="body-regular-large neutral-20-dark--text">
      {{ $t('message.pages.analyticsV3.errorState.title') }}
    </span>
    <span class="body-regular-small mt-1 neutral-40-light--text">
      {{ $t('message.pages.analyticsV3.errorState.description') }}
    </span>
    <base-btn class="mt-4" size="small" @click="refreshPage">
      {{ $t('message.pages.analyticsV3.errorState.refresh') }}
    </base-btn>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'AnalyticsErrorState',
  methods: {
    ...mapMutations('analytics', ['UPDATE_ERROR_STATE']),
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    refreshPage() {
      this.UPDATE_ERROR_STATE(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.error-state {
  &__image {
    width: 237px;
    margin-top: -60px;
  }
  &__container {
    margin: auto;
    background: varFigma(neutral-100-white);
    border-radius: 8px;
    height: 80vh;
  }
}
</style>
